module.exports = __webpack_public_path__ + "static/img/7.973ef95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/7.png
// module id = RIDN
// module chunks = 0